import i18n from '@/i18n';
import {eventBus} from '@/main';

const SET_LOCALE = 'SET_LOCALE';

const getDefaultLocale = () => {
  return i18n.load();
};

const state = {
  locale: getDefaultLocale()
};

const getters = {
  getLocale: state => {
    return state.locale;
  },
  getLanguageCode: state => {
    return state.locale.substring(0, state.locale.indexOf('_'));
  }
};

const mutations = {
  [SET_LOCALE] (state, locale) {
    state.locale = locale;
  }
};

const actions = {
  setLocale ({ commit }, { context, locale }) {
    if (getters.getLocale(state) !== locale) {
      commit(SET_LOCALE, locale);
      i18n.save(locale);
      context.$i18n.locale = locale;
      eventBus.$emit('languageChanged', locale);
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/locale/index.js